import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
  name: 'momentDiff',
  standalone: true
})
export class MomentDiffPipe implements PipeTransform {
  transform(
    value: string | Date | moment.Moment,
    unit: 'days' | 'months' | 'years' = 'days',
    compareTo: string | Date | moment.Moment = new Date(),
    absolute: boolean = true
  ): number {
    if (!value || !compareTo) return 0;

    // Convert to Moment and strip time
    const start = moment(value).startOf('day');
    const end = moment(compareTo).startOf('day');

    // Get difference in whole units
    const diff = start.diff(end, unit, false); // 'false' ensures whole units
    return absolute ? Math.abs(diff) : diff;
  }
}
